export enum SigningPageViewTypes {
  preparing = 'preparing',
  signing = 'signing',
  signingContract = 'signing-contract',
  pending = 'pending',
  pinConfirmation = 'pin-confirmation',
  banklinkSigning = 'banklink-signing',
  idCardSigning = 'id-card-signing',
  signingFailed = 'signing-failed',
}

export enum SignatureStatus {
  PREPARING = 'preparing',
  READY = 'ready',
  WAITING = 'waiting',
  SIGNED = 'signed',
  FAILED = 'failed',
  NOT_FOUND = 'not_found',
}
